import React from 'react'
import {
    Card, CardImg, CardText, CardBody, UncontrolledCollapse,
    Button,
    Container
} from 'reactstrap';

import ConfigSitio from '../../../../public/img/Help/ConfigSitio.png';
import ConfigMail from '../../../../public/img/Help/ConfigMail.png';

const Configuracion = () => {
    return (
        <Container fluid className="rounded contenedor-scrolleable">
            <header>
                <h2 className="text-center">Configuración de Sitio y Correos</h2>
            </header>
            <div>
                <Button color="primary" id="LPInicio" style={{ marginBottom: '1rem' }}>
                    Definiendo la Configurando del Sitio / Sistema
                </Button>
                <UncontrolledCollapse toggler="#LPInicio">
                    <Card>
                        <CardImg top src={ConfigSitio} className="img-fluid" alt="Configuracion de Sitio" title="Configuracion de Sitio" />
                        <CardBody>
                            <CardText>
                            La página de Configuración de Sitio centraliza ciertas configuraciones que han de ser de interés para el administrador, allí sé podra especificar:
                                <ul>
                                    <li>La URL de la web tienda de la empresa</li>
                                    <li>Si se desea utilizar la descripción del artículo en SIGE como titulo del artículo en web</li>
                                    <li>Si se quiere quitar ciertos filtros y/o reordenarlos en la tienda</li>
                                    <li>El punto de venta en SIGE asignado a la tienda</li>
                                    <li>El Logo de Empresa a utilizar como firma en los emails</li>
                                    <li>Si se desea importar y/o exportar clientes al SIGE</li>
                                    <li>Habilitar o Deshabilitar Login y Creación de Pedidos</li>
                                </ul>
                            </CardText>
                        </CardBody>
                    </Card>
                </UncontrolledCollapse>
                <br />
                <Button color="primary" id="CPInicio" style={{ marginBottom: '1rem' }}>
                    Configurando los correos
                </Button>
                <UncontrolledCollapse toggler="#CPInicio">
                    <Card>
                        <CardImg top src={ConfigMail} className="img-modal-content" alt="Adjuntar Fichero" title="Adjuntar Fichero" />
                        <CardBody>
                            <CardText>
                            La ventana de Configuración de Sitio centraliza ciertas configuraciones en relación a eventos que ocurren tanto en tienda como con SIGE Pedidos.
                            Se define que eventos se atienden y cuales se ignora, la casilla remitente a usar y a que correo enviar emails ante ciertos eventos.
                            </CardText>
                        </CardBody>
                    </Card>
                </UncontrolledCollapse>
                <br />
            </div>
        </Container>
    )
}
export default Configuracion;


// WEBPACK FOOTER //
// ./src/views/Ayuda/Paneles/Configuracion.js